export default "__VITE_ASSET__D1EggP8t__"